<template>
  <page-wrapper :title="title">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Scan" name="scan">
        <div v-if="showScan" class="qr-scanner">
          <strong v-if="hasCameraPermission">Scan here</strong>
          <div v-if="cameraError" class="camera-error">{{ cameraError }}</div>
          <qrcode-stream
            v-else
            class="camera-scanner"
            @decode="onDecode"
            @init="onCameraInit"
          ></qrcode-stream>
          <label class="label">Event Name</label>
            <el-input v-model="eventName" :disabled="true"></el-input>
        </div>
        <div v-if="!showScan" class="result-detail">
          ID: {{user.id}}<br/>
          FirstName: {{user.first_name}}<br/>
          LastName: {{user.last_name}}<br/>
          Mobile: {{user.mobile_number}}<br/>
          E-mail: {{user.email}}<br/>
          <hr/>
          <span v-for="(home, index) in user.user_home_entities" :key="index" class="home-list-detail">
            <input
              v-model="homeId"
              :value="home.home_id"
              type="radio"
            />
            Home: {{home.home.address_no}}<br/>
            &nbsp; &nbsp; Project: {{home.project.project_code}}<br/>
          </span><br/>
          <div class="text-center action-button">
            <sc-button variant="primary" @click="onSubmit()">Check-in</sc-button>
            <sc-button variant="primary" @click="onCancel()">Cancel</sc-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Report" name="report">
        <div class="report">
          <div  class="report-header"><strong>7 Days event</strong></div>
          <table class="table">
            <tbody>
              <tr v-for="(report, index) in reports" :key="index">
                <td>
                  <span v-if="index===0">{{report.date}}</span>
                  <span v-if="index>0 && reports[index-1].date !== report.date">{{report.date}}</span>
                </td>
                <td>{{report.event_name}}</td>
                <td>
                    {{report.count}}
                    <download-excel
                      :fields="exportFields"
                      :fetch="()=>{return fetchEventReport(report.event_name, report.date)}"
                      class="el-button"
                      type="xls"
                      name="checkin-report.xls"
                      >&nbsp;
                    </download-excel>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-tab-pane>
    </el-tabs>

  </page-wrapper>
</template>
<script>

import Vue from "vue";
import JsonExcel from "vue-json-excel";
import VeeValidate from "vee-validate";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { Input, Tabs, TabPane } from "element-ui";
import { QrcodeStream } from 'vue-qrcode-reader'
import { baanRueJaiClient } from "@/dependencies";
import { getCookie, Auth } from "@/lib/cookie";

Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields'
});

export default {
  name: 'QrCheckin',
  components: {
    "el-input": Input,
    PageWrapper,
    ScButton,
    QrcodeStream,
    downloadExcel: JsonExcel
  },
  data() {
    const eventName = this.$route.query.event !== undefined
      ? this.$route.query.event.toUpperCase()
      :  ""

    return {
      title: "QR Check-in",
      userId: "",
      showScan: true,
      user: {},
      reports: [],
      eventName,
      activeName: 'scan',
      homeId: undefined,
      cameraError: "",
      hasCameraPermission: false,
      exportFields: {
        "event": "event_name",
        "user_id": "user_id",
        "first name": "first_name",
        "last name": "first_name",
        "mobile": "mobile_number",
        "project": "project_code",
        "address": "address_no",
        "role": "user_role",
        "check-in time": "checkin_at"
      }
    }
  },
  computed: {
  },
  async created() {
    this.checkAuthen();
  },
  methods: {
    checkAuthen() {
      const token = getCookie(Auth.AccessToken);
      if (token === null) {
        this.$router.push({
        path: "/admins/logins",
        query: { redirect: `/admins/management/qrcheckin?event=${this.$route.query.event}`}
      });
      }
    },
    async onDecode (decodedString) {
      if (decodedString !== "") {
        const snd = new Audio('/static/sounds/beep.mp3');
        snd.play();

        this.showScan = false;
        this.userId = decodedString;
        this.user = await this.fetchUser();
        if (this.user.user_home_entities[0] !== undefined) {
          this.homeId = this.user.user_home_entities[0].home_id
        }
      }
    },
    async onSubmit() {
      baanRueJaiClient.admin.users.postCheckin({
        userId: this.user.id,
        eventName: this.eventName,
        homeId: this.homeId })
      .then(() => {
        this.$message.success("success");
        this.userId = "";
        this.user = {};
        this.showScan = !this.showScan;
        this.homeId = undefined;
      })
      .catch((err)=>{
        this.$message.error(err.response.data.message);
      });
    },
    onCancel() {
      this.userId = "";
      this.user = {};
      this.showScan = !this.showScan;
    },
    async onCameraInit(promise) {
      this.cameraError = "";
      this.hasCameraPermission = false;

      try {
        await promise;
        this.hasCameraPermission = true;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.cameraError = "กรุณาอนุญาตให้เข้าถึงกล้องเพื่อสแกน QR Code";
        } else if (error.name === "NotFoundError") {
          this.cameraError = "ไม่พบกล้องที่ใช้งานได้บนอุปกรณ์นี้";
        } else if (error.name === "NotSupportedError") {
          this.cameraError = "หน้านี้ต้องเปิดผ่าน HTTPS หรือ localhost เพื่อใช้กล้อง";
        } else if (error.name === "NotReadableError") {
          this.cameraError = "กล้องถูกใช้งานโดยแอปอื่นอยู่";
        } else if (error.name === "OverconstrainedError") {
          this.cameraError = "ไม่พบกล้องที่ตรงกับเงื่อนไขที่ร้องขอ";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.cameraError = "เบราว์เซอร์นี้ไม่รองรับการใช้กล้อง";
        } else {
          this.cameraError = "ไม่สามารถเข้าถึงกล้องได้ กรุณาลองใหม่อีกครั้ง";
        }
      }
    },
    async handleClick(tab) {
      if (tab.name === 'report') {
        this.reports = await this.fetchTodayReport();
      }
    },
    async fetchUser() {
      const response = await baanRueJaiClient.admin.users.getByQR(this.userId);
      return response.data.result;
    },
    async fetchTodayReport() {
      const response = await baanRueJaiClient.admin.users.getTodayReport();
      return response.data.result;
    },
    async fetchEventReport(eventName, date) {
      const response = await baanRueJaiClient.admin.users.getEventReport(eventName, date);
      return response.data.result;
    }
  }
}

</script>
<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}

.qr-scanner {
  padding: 30px;
  border-bottom: $border;
}

.camera-error {
  padding: 20px;
  color: $danger-color;
  text-align: center;
}

.camera-scanner {
  height: 350px;
}

.result-detail {
  padding: 30px;
}

.home-list-detail{
  display: block;
  padding-left: 10px;
  padding-bottom: 5px;
}

.report {
  padding: 15px;
}

.report-header {
  padding-bottom: 20px;
}

.report-link {
  cursor:pointer;
  color:blue;
  text-decoration:underline;
}

.report-link:hover {
  text-decoration:none;
  text-shadow: 1px 1px 1px #555;
}

.action-button {
  padding: 10px;
  padding-top: 30px;
}

.dot {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}

.el-button {
  width: 28px;
  height: 28px;
  padding: 1px;
  border-radius: 7px;
  background: url("/static/icons/download.svg");
  background-repeat: no-repeat;
  font-size: 14px;
}
</style>
